import { fmtCr } from "@/lib/api";

export const KpiCard = ({ label, value, sub, tone = "amber", testid, delay = 0 }) => {
  const toneCls = { amber: "text-amber-400", pos: "text-emerald-400", neg: "text-rose-400", blue: "text-sky-400" }[tone];
  return (
    <div className="panel p-4 lg:p-5 fade-up [container-type:inline-size]" style={{ animationDelay: `${delay}ms` }} data-testid={testid}>
      <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">{label}</div>
      <div className={`num mt-2 whitespace-nowrap font-semibold tracking-tight ${toneCls}`} style={{ fontSize: "clamp(12px, 9.5cqi, 28px)" }} data-testid={`${testid}-value`}>
        {value}
      </div>
      {sub && <div className="mt-1.5 text-xs text-slate-500">{sub}</div>}
    </div>
  );
};

export const Panel = ({ title, subtitle, actions, children, className = "", testid }) => (
  <section className={`panel p-4 lg:p-6 fade-up ${className}`} data-testid={testid}>
    {(title || actions) && (
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          {title && <h3 className="text-base font-semibold text-slate-100">{title}</h3>}
          {subtitle && <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    )}
    {children}
  </section>
);

export const PageHeader = ({ kicker, title, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4 fade-up">
    <div>
      <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-500/90">{kicker}</div>
      <h1 className="mt-1 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-50">{title}</h1>
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const ChartTip = ({ active, payload, label, percentKeys = [] }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-slate-700 bg-[#0f172a] px-3 py-2 shadow-xl">
      <div className="mb-1 text-[11px] font-semibold text-slate-300">FY {label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center justify-between gap-6 text-[11px]">
          <span className="flex items-center gap-1.5 text-slate-400">
            <i className="inline-block h-2 w-2 rounded-full" style={{ background: p.color || p.fill }} />
            {p.name}
          </span>
          <span className="num text-slate-100">
            {percentKeys.includes(p.dataKey) ? `${(p.value * 100).toFixed(1)}%` : fmtCr(p.value)}
          </span>
        </div>
      ))}
    </div>
  );
};

export const StatusBadge = ({ ok, children, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
      ok ? "bg-emerald-500/10 text-emerald-400 ring-1 ring-emerald-500/30" : "bg-rose-500/10 text-rose-400 ring-1 ring-rose-500/30"
    }`}
  >
    {children}
  </span>
);

export const Empty = ({ children }) => <div className="py-10 text-center text-sm text-slate-500">{children}</div>;
